/******************************

  bm-script.js

*******************************/

// 追従バナー
document.addEventListener("scroll", function () {
    const floatingBanner = document.getElementById("js-pagetop");
    const scrollTop = window.scrollY || document.documentElement.scrollTop;
    const windowHeight = window.innerHeight;
    const documentHeight = document.documentElement.scrollHeight;

    // ページの一番下に到達した場合、hiddenクラスを追加して非表示にする
    if (scrollTop + windowHeight >= documentHeight) {
        floatingBanner.classList.add("is-hidden");
    } else {
        floatingBanner.classList.remove("is-hidden");
    }
});

// トップページ ファーストビュー
const mainSliders = document.querySelectorAll("#js-mainv-slider");

mainSliders.forEach(mainSlider => {
    const splide = new Splide(mainSlider, {
        type: "loop",
        autoplay: true,
        interval: 3500, // 自動再生の間隔
        speed: 800, // スライダーの移動時間
        pagination: true,
        arrows: true,
    });

    // paginationを指定の要素に挿入する
    splide.on('pagination:mounted', (pagination) => {
        // カスタムのpagination要素を取得
        const customPaginationContainer = mainSlider.parentElement.querySelector('#custom-pagination');

        if (customPaginationContainer) {
            customPaginationContainer.appendChild(pagination.list);
        }
    });

    splide.mount();
});

// ハンバーガーメニュー
document.querySelector("#js-trigger-menu").addEventListener("click", function() {
    // #js-trigger-menuにactiveクラスをトグル
    this.classList.toggle("active");
    // .l-header__gnavにopenクラスをトグル
    document.querySelector(".l-header__spnav").classList.toggle("open");
});

// header メガメニュー
document.querySelector('#js-mega-menu').addEventListener('click', function() {
    this.classList.toggle('active');

    const headerMega = document.querySelector('.l-header__mega');
    if (headerMega) {
      headerMega.classList.toggle('open');
    }
});
